import type { FunctionComponent } from 'react'

import styles from './article-thumbnails.module.scss'
import SectionOfThumbnails from '@contentful-components/section-of-thumbnails/section-of-thumbnails'
import type { SectionOfThumbnailsFragment } from '@graphql/fragments/SectionOfThumbnailsFragment.graphql'

/**
 * Renders a section of thumbnails, styled for articles.
 */
export const ArticleThumbnails: FunctionComponent<
    SectionOfThumbnailsFragment
> = (props) => (
    <div className={styles.section}>
        <SectionOfThumbnails {...props} />
    </div>
)
